
import { useParams } from "react-router-dom";
import EditProductPage from "./edit-product/EditProductPage";
import ProtectedRoute from "@/components/ProtectedRoute";

const EditProduct = () => {
  const { productId } = useParams<{ productId: string }>();
  
  console.log(`EditProduct component rendering with productId: ${productId}`);
  
  return (
    <ProtectedRoute>
      <EditProductPage productId={productId} />
    </ProtectedRoute>
  );
};

export default EditProduct;
